import React from "react"
import Testimonials from "../swiper/testimonials-new"
import loadable from "@loadable/component"
import pMinDelay from "p-min-delay"
import { Col, Container, Row } from "react-bootstrap"
import { LazyLoadComponent } from "react-lazy-load-image-component"

const TraditionalSection = loadable(() =>
  pMinDelay(import("./TraditionalSection"), 500)
)
const BuildSection = loadable(() => pMinDelay(import("./BuildSection"), 500))
const CaseStudiesSection = loadable(() =>
  pMinDelay(import("./CaseStudiesSection"), 500)
)
const TransformSection = loadable(() =>
  pMinDelay(import("./TransformSection"), 500)
)
const StreamlineSection = loadable(() =>
  pMinDelay(import("./StreamlineSection"), 500)
)
const TrialSection = loadable(() => pMinDelay(import("./TrialSection"), 500))

const QuickbaseSections = props => {
  return (
    <>
      <TraditionalSection />
      <BuildSection />
      <CaseStudiesSection props={props} />
      <TransformSection />
      <StreamlineSection />
      <LazyLoadComponent>
        <Testimonials />
      </LazyLoadComponent>
      <LazyLoadComponent>
        <div id="quick-base-free-trial">
          <div className="text-center" style={{ backgroundColor: "#2C9382" }}>
            <Container>
              <p className="text-white m-0 py-2 text-18">
                <span className="font-weight-bold">
                  HAVE QUESTIONS BEFORE SIGNING UP?{" "}
                </span>
                Give Us A Call At{" "}
                <a
                  aria-label="link"
                  href="tel:+17207391406"
                  onclick="ga('send', 'event', 'Phone Call Tracking', 'Click to Call', '720-739-1406', 0);"
                  className="text-white"
                >
                  (720) 739-1406.
                </a>{" "}
                
              </p>
            </Container>
          </div>
        </div>
        <TrialSection />
      </LazyLoadComponent>
    </>
  )
}

export default QuickbaseSections
